angular.module('mtic.components.translation', [

])

angular.module('mtic.components.translation').component('languageSpan', {
  template: '<span class="{{$ctrl.class}}" ng-bind="$ctrl.getText()"></span>',
  bindings: {
    class: '@',
    langId: '@'
  },
  controller: function(language) {
    this.getText = function() {
      return language.get(isNaN(this.langId) ? this.langId : Number(this.langId))
    };
  }
});
